/** ⌘K rows and group headings (design 29b): the selected row gets a terracotta edge. */
export const SEARCH_ROW_CLASS =
  'flex min-h-9 items-center gap-2.5 rounded-lg px-2.5 py-1.5 text-[13.5px] text-foreground data-[selected=true]:bg-accent data-[selected=true]:shadow-[inset_2px_0_0_var(--brand)] phone:min-h-12 phone:text-[15px]'

export const SEARCH_GROUP_CLASS =
  'p-0 px-1.5 [&_[cmdk-group-heading]]:px-2.5 [&_[cmdk-group-heading]]:pb-1 [&_[cmdk-group-heading]]:pt-2.5 [&_[cmdk-group-heading]]:text-[10.5px] [&_[cmdk-group-heading]]:font-semibold [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.06em]'
